import { ApiError, apiErrorReason } from '@/lib/api';

import type { RelationDirection, RelationType } from './types';

// Textos de los documentos relacionados (spec §6.2.6). La relación es dirigida: el
// origen menciona (relacionado) o impacta al destino; se describe siempre desde el
// documento que se está viendo. Cero enums crudos (UX-COPY-01).

const LABELS: Record<RelationDirection, Record<RelationType, string>> = {
  outgoing: { relacionado: 'Este documento lo menciona', impacta: 'Un cambio aquí lo impacta' },
  incoming: { relacionado: 'Menciona a este documento', impacta: 'Un cambio allá impacta a este' },
};

export function relationLabel(row: {
  direction: RelationDirection;
  relationType: RelationType;
}): string {
  return LABELS[row.direction][row.relationType];
}

const REJECTIONS: Record<string, string> = {
  relation_exists: 'Esos documentos ya están relacionados.',
  self_relation: 'Un documento no se relaciona consigo mismo. Elige otro.',
  annulled_document: 'Un documento anulado no admite relaciones. Elige otro.',
};

export function relationError(err: unknown): string {
  const reason = apiErrorReason(err);
  if (reason !== undefined && REJECTIONS[reason] !== undefined) {
    return REJECTIONS[reason];
  }
  if (err instanceof ApiError && err.status === 404) {
    return 'Uno de los documentos ya no existe. Recarga la ficha.';
  }
  if (err instanceof ApiError && err.status === 403) {
    return 'No tienes permiso para relacionar documentos. Pide acceso al Administrador de Calidad.';
  }
  return 'No se pudo guardar. Intenta de nuevo.';
}
